import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const role = await login(email, password);
      navigate(role === 'admin' ? '/admin' : '/');
    } catch (err) {
      setError('Feil brukernavn eller passord');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-8 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold text-center text-[#000099] mb-6">
        Logg inn
      </h1>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          placeholder="E-post"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#000099]"
          required
        />

        <input
          type="password"
          placeholder="Passord"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#000099]"
          required
        />

        <button
          type="submit"
          className="w-full bg-[#000099] text-white font-semibold py-2 px-4 rounded hover:bg-blue-800 transition-colors"
        >
          Logg inn
        </button>

      </form>
      <div className="text-sm text-center mt-4">
  Ikke registrert?{' '}
  <Link
  to="/register"
  className="text-[#000099] underline hover:text-blue-800"
>
  Registrer deg her
</Link>
<p className="text-sm mt-2">
  <a className="underline text-[#000099]" href="/forgot-password">Glemt passord?</a>
</p>
</div>
    </div>
  );
}

export default LoginPage;
